import { useRestResourceHook } from "../use-rest-resource-hook";
import {
  RootComponentsRestResource,
  GetRootComponentsRequest,
  GetRootComponentsResponse,
  UpdateRootComponentsDeletionFlagsResponse,
  UpdateRootComponentsDeletionFlagsRequest,
} from ".";

export const useGetRootComponents = () =>
  useRestResourceHook<GetRootComponentsRequest, GetRootComponentsResponse>(
    (request) => RootComponentsRestResource.getRootComponents(request),
  );

export const useUpdateRootComponentsDeletionFlags = () =>
  useRestResourceHook<
    UpdateRootComponentsDeletionFlagsRequest,
    UpdateRootComponentsDeletionFlagsResponse
  >((request) =>
    RootComponentsRestResource.updateRootComponentsDeletionFlags(request),
  );
